import { render, staticRenderFns } from "./pieChartReplaceReason.vue?vue&type=template&id=0a0a6459"
import script from "./pieChartReplaceReason.vue?vue&type=script&lang=js"
export * from "./pieChartReplaceReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports